import { getEditTranslationsPrivilege } from '@skytech/utils'

import type { TokenData } from '@/types'

const getUserFromToken = (tokenData: TokenData) => {
  const user = {
    id: tokenData.uid,
    whiteLabelId: tokenData.wlid,
    costObjectId: tokenData.coid,
    customerId: tokenData.cid,
    customerHeadId: tokenData.chid,
    editTranslationsPrivilege: getEditTranslationsPrivilege(tokenData.ia),
  }

  return user
}

export default getUserFromToken
